namespace Matrix.Rebalancer {
    export class SortSettingsColumns {
        static columnsKey = 'Rebalancer.SortSettings';
    }
}
